import React, { Component} from "react";
import TransferCuentasPropiasService from "../../../../services/transferencias/TransferCuentasPropiasService";
import CuentaSocioTransferencia from "../../../generico/CuentaSocioTransferencia";
import NumberFormat from "react-number-format";
import { trackPromise } from "react-promise-tracker";
import Popup from "react-popup";
import { splitImporte } from "../../../generico/utils/FormatoInput";
import DataTable from "react-data-table-component";
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import $ from "jquery";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import Authservice from "../../../../services/login/auth.service";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage:true
};
var pagoRuedaObj = undefined; //// utilizado cuando se realiza un pago desde el resumen general - rueda
export default class TransferCuentasPropias extends Component {
  TIPO_DEBITO = "D";
  TIPO_CREDITO = "C";
  constructor(props) {
    super(props);
    this.getCuentasOrigen = this.getCuentas.bind(this);
    this.state = this.getInitialState();
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  getInitialState = () => ({
    cuentasOrigen: [],
    cuentasDestino: [],
    cuentaDebito: "",
    cuentaCredito: "",
    monto: 0,
    cuentaOrigenSelected: [],
    itemSelected: { value: "-1", label: "--Seleccione--" },
    detalleCuenta: "",
    cuentasAcreditar:[],
    //pagoRueda:null //// utilizado cuando se realiza un pago desde el resumen general - rueda
  });
  resetState = () => {
    this.setState(this.getInitialState());
  };
  componentDidMount() {
    this.initPagoRueda();
    this.initData();
  }

  initData = () => {
    this.resetState();
    this.getCuentas(this.TIPO_DEBITO);
    this.getCuentas(this.TIPO_CREDITO);
  };
   newTransferBtn = () => {
    this.initData();
  };

  /**
   * @author m_bareiro
   * obtiene los datos de rueda seleccionada en la pantalla de resumen general
   */
  initPagoRueda(){ 
    pagoRuedaObj = JSON.parse(sessionStorage.getItem("PAGO_RUEDA"));
    sessionStorage.removeItem("PAGO_RUEDA");
  }

  selectorValue = (dataFromChild, item) => {
    this.setState(
      {
        cuentaOrigenSelected: dataFromChild,
        cuentaDebito: dataFromChild.ahorro,
        detalleCuenta: dataFromChild.ahorro + " - " + Authservice.getSocio().nombreCompleto.trim(),
        itemSelected: item,
      },
      this.checkGrilla
    );
  };
  montoValue = (_monto) => {
    this.setState(
      {
        monto: _monto,
      },
      this.checkGrilla
    );
  };
  getCuentas(tipo) {
    trackPromise(
      TransferCuentasPropiasService.getCuentas(tipo).then((response) => {
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        if (tipo === this.TIPO_DEBITO) {
          var cuentasDebitar = (jsonData.resultadoAH !== null ?jsonData.resultadoAH:[]);
          if(jsonData.resultadoAF !== null){
            for (let index = 0; index < jsonData.resultadoAF.length; index++) {
              cuentasDebitar.push(jsonData.resultadoAF[index]);
            }
          }
          this.setState({ cuentasOrigen: cuentasDebitar });
        } else if (tipo === this.TIPO_CREDITO) {
          this.setState({ cuentasDestino: jsonData});
          this.setState({cuentasAcreditar: this.getListaCuentas()});
      
          //// pago rueda - resumen general
          if(pagoRuedaObj !== null && pagoRuedaObj !== undefined){
            let listaAux = this.state.cuentasAcreditar;
            let index = listaAux.findIndex(d => d.cuenta === pagoRuedaObj.cuenta && d.grupo === pagoRuedaObj.grupo); // obtiene el index
            let cuentaSeleccionada = listaAux.splice(index, 1); // elimina y obtiene del listado del listado
            listaAux.unshift(cuentaSeleccionada[0]); //// inserta en la primera posicion
      
            this.setState({ monto:pagoRuedaObj.importeCuota, cuentasAcreditar: listaAux});

            setTimeout(function(){
              //var radio = document.getElementById("radio_" + this.state.pagoRueda.cuenta+"_"+this.state.pagoRueda.grupo)
              var radio = document.getElementById("radio_" + pagoRuedaObj.cuenta+"_"+pagoRuedaObj.grupo)
              radio.click();
              this.ctaDestinoSel = radio;
            }, 100);
            
          }
        }
      })
    );
  }

  loadDataConfirm() {
    var datos = this.state.cuentaOrigenSelected;

    var _itemsConfirm = [
      { concepto: "Cuenta Débito", valor: this.state.cuentaDebito },
      {
        concepto: "Importe del Débito en " + datos.moneda,
        valor: (
          <NumberFormat
            value={this.state.monto}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
          />
        ),
      },
      { concepto: "Cuenta Crédito", valor: this.state.cuentaCredito },
      {
        concepto: "Importe del Crédito en " + datos.moneda,
        valor: (
          <NumberFormat
            value={this.state.monto}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
          />
        ),
      },
      { concepto: "Titular de la Cuenta Destino", valor: Authservice.getSocio().nombreCompleto.trim() },
      {
        concepto: "Fecha de Operación",
        valor: (new Date()).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
      },
    ];

    return _itemsConfirm;
  }
  precondTrasnferir() {
    if (
      this.state.cuentaDebito === "" ||
      this.state.cuentaDebito === undefined
    ) {
      Popup.queue(this.notifiPopup("Info", "Debe cargar la cuenta de Débito"));

      return false;
    }
    if (this.state.cuentaCredito === "") {
      Popup.queue(this.notifiPopup("Info", "Debe cargar la cuenta de Crédito"));

      return false;
    }
    if (this.state.cuentaDebito === this.state.cuentaCredito) {
      Popup.queue(
        this.notifiPopup(
          "Info",
          "Las cuentas de Débito y crédito no pueden ser las mismas"
        )
      );

      return false;
    }

    if (
      this.state.monto.toString().trim().length === 0 ||
      splitImporte(this.state.monto) === "0"
    ) {
      Popup.queue(this.notifiPopup("Info", "El monto debe ser mayor a 0"));
      return false;
    }
    return true;
  }

  getColumn() {
    return [
      {
        cell: (row) => (
          <input
            ref={() => this.ctaDestinoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.cuenta}
            type="radio"
            name="rowRadio"
            value={row.cuenta}
            onClick={this.selCtaDestinoEvt}
          ></input>
        ),
        width: "50px",
      },
      {
        name: "Cuenta",
        selector: row => row.cuenta,
      },
      {
        name: "Saldo",
        selector: row => row.saldo,
      },
      {
        name: "Denominación",
        selector: row => row.denominacion,
      },
    ];
  }
  selCtaDestinoEvt = (e) => {
    this.ctaDestinoSel = e.currentTarget;
    this.setState(
      { cuentaCredito: this.ctaDestinoSel.value },
      this.checkGrilla
    );
    var destino = this.ctaDestinoSel.value;
    var foundItem = $.grep(this.state.cuentasAcreditar, function (v) {
      var item = v.cuenta;
      return item.trim() === destino.toString();
    });
    this.setState({cuentasDestinoSelected:foundItem[0]});
  };

  getListaCuentas() {
    var respuesta = [];
    var itemsAhorro =  [];
    var itemsRueda =  [];
    var itemsProgramado =  [];
    if(this.state.cuentasDestino.resultadoAH === undefined || this.state.cuentasDestino.resultadoAH === null){
      itemsAhorro =  [];
    }else{
      itemsAhorro = this.state.cuentasDestino.resultadoAH;
    }

    if(this.state.cuentasDestino.resultadoAP === undefined || this.state.cuentasDestino.resultadoAP === null){
      itemsRueda = [];
    }else{
      itemsRueda = this.state.cuentasDestino.resultadoAP;
    }

    if(this.state.cuentasDestino.resultadoAG === undefined || this.state.cuentasDestino.resultadoAG === null){
      itemsProgramado = [];
    }else{
      itemsProgramado = this.state.cuentasDestino.resultadoAG;
    }
    
    if(itemsAhorro !== null){
      for (var i = 0; i < itemsAhorro.length; i++) {
        respuesta.push({
          id: itemsAhorro[i].ahorro,
          cuenta: itemsAhorro[i].ahorro,
          saldo:
            formatoSeparadorMilesValue(itemsAhorro[i].saldoTotal) +
            " " +
            itemsAhorro[i].moneda,
          denominacion: itemsAhorro[i].descripcion,
          tipoCuenta : itemsAhorro[i].tipoCuenta,
          plan: null,
          grupo: null
        });
      }
    }
    
    if(itemsRueda !== null){
      for (var i = 0; i < itemsRueda.length; i++) {
        respuesta.push({
          id: itemsRueda[i].ahorro +"_"+ itemsRueda[i].grupo,
          cuenta: itemsRueda[i].ahorro,
          saldo:
            formatoSeparadorMilesValue(itemsRueda[i].totalDeposito) +
            "  GS",
          denominacion: itemsRueda[i].descripcion,
          tipoCuenta: itemsRueda[i].tipoCuenta,
          plan: itemsRueda[i].plan,
          grupo: itemsRueda[i].grupo
        });
      }
    }
    
    if(itemsProgramado !== null){
      for (var i = 0; i < itemsProgramado.length; i++) {
        respuesta.push({
          id: itemsProgramado[i].ahorro,
          cuenta: itemsProgramado[i].ahorro,
          saldo:
            formatoSeparadorMilesValue(itemsProgramado[i].saldoTotal) +
            " " +
            itemsProgramado[i].moneda,
          denominacion: itemsProgramado[i].descripcion,
          tipoCuenta: itemsProgramado[i].tipoCuenta,
          plan: null,
          grupo: null
        });
      }
    }

    return respuesta; 
  }
  checkGrilla() {
    if (this.ctaDestinoSel !== undefined) {
      $("#" + this.ctaDestinoSel.id).prop("checked", true);
    }
  }  
  seleccionarFila = state => {
    var radio = document.getElementById("radio_" + state.id)
    radio.click();
    this.ctaDestinoSel = radio;
    this.setState({ cuentasDestinoSelected: state});
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuentas
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">                
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>

              <li role="tab" className="disabled last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <form
          ref={(c) => {
            this.form = c;
          }}
          onSubmit={(e) => e.preventDefault()}
        >
          <section className="content">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-5">
                      <CuentaSocioTransferencia
                        renderMonto="true"
                        selectorValue={this.selectorValue.bind(this)}
                        montoValue={this.montoValue.bind(this)}
                        operacion="DEBITO"
                        tipoCuenta="AHORRO_VISTA"
                        items={this.state.cuentasOrigen}
                        monto={this.state.monto}
                        itemSelected={this.state.itemSelected}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <label className="input-label-bold">
                        Seleccione la Cuenta Destino (a acreditar) *
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <DataTable
                      noHeader={false}
                      pagination={true}
                      columns={this.getColumn()}
                      //data={this.getListaCuentas()}
                      data={this.state.cuentasAcreditar}
                      dense={true}
                      paginationComponentOptions={paginationOptions}
                      noDataComponent="No hay registros para mostrar"
                      responsive={true}
                      striped={true}
                      onRowClicked={this.seleccionarFila}
                      className="tablaaaaa"
                      pointerOnHover
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </form>

        <hr />

        <div className="row">
          <div className="col-lg-10 col-md-8">
            <div className="row">
              <label
                className="input-label-bold-obligatorio">
                (*) Campos Obligatorios
                <br />
              </label>
            </div>
          </div>
          <div className="col-lg-2 col-md-4">
              <button
                disabled={this.state.disableSgte}
                className="btn btn-cu-primary"
                onClick={(e) => {
                  if (!this.precondTrasnferir()) {
                    e.preventDefault();
                  } else {
                    var items = this.loadDataConfirm();
                    this.props.returnDataPaso1(
                      this.state.cuentaDebito,
                      this.state.cuentaCredito,
                      this.state.monto,
                      items,
                      this.state.detalleCuenta,
                      this.state.cuentaOrigenSelected,
                      this.state.cuentasDestinoSelected
                    );
                    this.nextStep.click();
                  }
                }}
              >
                Continuar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
            
          </div>
        </div>

      </div>
    );
  }
}
